<template>
  <div class="ibox">

    <div class="ibox-content">

      <!-- Common error message -->
      <div v-if="error">
        <div class="alert alert-danger text-center">
          {{ error }}
        </div>
      </div>

      <div v-if="load.global" class="text-center mt-2">
        <!-- Loading indicator -->
        <i class="fa fa-spinner fa-spin fa-3x"></i>
        <div class="mt-2">Getting data from Twilio...</div>
      </div>
      <div v-else>
        <div class="alert alert-secondary text-center mb-3">
          This list contains only verified A2P services with the use case set to "Notify my users".
          In addition, services that have already been imported or reserved by CIMS for other needs are excluded.
        </div>

        <!-- Service list -->
        <div v-if="services.length" class="table-responsive">

          <table class="table table-striped table-hover mb-0">

            <thead>
            <tr>
              <th class="text-center w-50s">
                <checkbox-list-toggler
                  :ids="services.map(s => s.id)"
                  @items-updated="(ids) => selectedIds = ids">
                </checkbox-list-toggler>
              </th>

              <th>Name</th>
              <th>Created</th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="(service, index) in services">

              <td class="text-center">
                <checkbox-toggler :index="index" :id="service.id">
                </checkbox-toggler>
              </td>

              <td>{{ service.name }}</td>
              <td>{{ service.created }}</td>
            </tr>
            </tbody>

          </table>

        </div>
        <div v-else>
          <div class="alert alert-warning text-center m-t-xs mb-0">
            No services found available for import.
          </div>
        </div>

      </div>

    </div>

    <div class="ibox-footer text-right">
      <a :href="servicePoolLink" class="btn btn-default mr-1"><i class="fa fa-fw fa-ban"></i> Cancel</a>
      <button v-if="!load.global" type="button" class="btn btn-primary" :disabled="!selectedIds.length" @click="processImport">
        <i class="fa fa-fw fa-cloud-download"></i> Import Selected
        <i v-if="load.process" class="fa fa-fw fa-spinner fa-spin"></i>
      </button>
    </div>

  </div>
</template>

<script>

export default {

    props: {

      // Route to service pool.
      servicePoolLink: {
        type: String,
        required: true
      },

      // Route to load available services.
      loadServicesLink: {
        type: String,
        required: true
      },

      // Route to import selected services.
      processImportLink: {
        type: String,
        required: true
      },

    },

    /**
     * Variables (models).
     */
    data () {
      return {
        // Service list.
        services: [],
        // Selected service ids.
        selectedIds: [],
        // Common error message.
        error: '',
        // Loading indication helpers.
        load: {
          global: false,
          process: false,
        },
      }
    },

    /**
     * Functions (methods).
     */
    methods: {

      /**
       * Init component.
       */
      init() {
        this.loadServices();
      },

      /**
       * Load services.
       */
      loadServices() {
        this.error = '';
        this.load.global = true;

        axios.get(this.loadServicesLink)
          .then(response => {
            this.services = response.data;
          })
          .catch(error => {
            this.handleErrors(error, 'Unable to load services.')
          })
          .then(() => {
            this.load.global = false;
          });
      },

      /**
       * Process import.
       */
      processImport() {
        this.error = '';
        this.load.process = true;

        const formData = new FormData();
        formData.append('services', JSON.stringify(this.selectedIds));

        axios.post(this.processImportLink, formData)
          .then(response => {
            window.location.assign(this.servicePoolLink);
          })
          .catch(error => {
            this.handleErrors(error, 'Unable to process request.')
          })
          .then(() => {
            this.load.process = false;
          });
      },

      /**
       * Handle axios errors
       *
       * @param errorObj
       * @param defaultMessage
       */
      handleErrors(errorObj, defaultMessage) {
        if (errorObj.response.status === 422) {
          this.error = errorObj.response.data.message || defaultMessage;
        } else {
          if (errorObj.response.status === 403) {
            this.error = defaultMessage + ': access denied.';
          } else {
            this.error = defaultMessage;
          }
        }
      },

    },

    /**
     * Component initialization.
     */
    mounted: function () {
      this.init();
    },
  }
</script>
